export const getRevDate = (date) => {
    var val = date.split(',')[0];
    return val.split('/')[2] + '-' + (val.split('/')[0] < 10 ? '0'+val.split('/')[0] : val.split('/')[0])+ '-' + (val.split('/')[1] < 10 ? '0'+val.split('/')[1] : val.split('/')[1]);
}

export function get24hoursTime(val) {
    var temp = val.split(/[^0-9]/);
    var dt = new Date (temp[0],temp[1]-1,temp[2],temp[3],temp[4],temp[5]);
    var hrs = dt.getHours();
    var mins = dt.getMinutes();
    return (hrs < 10 ? '0' + hrs : hrs) + ':' + (mins < 10 ? '0' + mins : mins);
}

export function getFormattedDayDate(val) {
    val = val.split(/[^0-9]/);
    const dt = new Date (val[0],val[1]-1,val[2],val[3],val[4],val[5] );
    const date = dt.getDate();
    const months    = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return  (date < 10 ? '0'+ date:date) + ' ' +(months[dt.getMonth()]);
}


export function get12to24hourtme(time){
    var PM = time.match('PM') ? true : false;
    time = time.split(/[ :]+/);//console.log(time);
    var min = time[2];
    var hour ="";
    if (PM) {
        hour = 12 + ( parseInt(time[1],10) === 12 ? 0 : parseInt(time[1],10))  
    } else {
        // console.log("time",typeof time[1]);
        hour = time[1] === '12' ? '00' : time[1];
    }
    return hour + ':' + min;
}

export function setTime(time){
    let hms = time && time.split(':');
    return hms[0] + ':' + hms[1];
   } 

export function getFormattedDate(val) {
    let value = val.split(',');
    let dateArr = value[0];
    let month = dateArr.split('/')[0];
    let date =  dateArr.split('/')[1];
    let year =  dateArr.split('/')[2];
    let timeArr = value[1];
    let hour = timeArr.split(':')[0].trim();
    let min =  timeArr.split(':')[1].trim();
    let sec =  timeArr.split(':')[2].trim();
    sec = sec.split(' ')[0];

    return (year+'-'+(month < 10 ? '0'+month : month)+'-'+(date < 10 ? '0'+date : date) +' '+ (hour < 10 ? '0'+hour : hour)+':'+min+':'+sec);
    
  }